import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const SubmitConfirmDialog = ({
  open,
  unansweredCount,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: 380,
          width: "100%",
        },
      }}
    >
      <DialogTitle fontWeight={600}>
        Submit Test?
      </DialogTitle>

      <DialogContent>
        <Typography>
          Are you sure you want to continue? You still have{" "}
          <strong>{unansweredCount}</strong>{" "}
          unattempted problem{unansweredCount !== 1 ? "s" : ""}.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          sx={{ textTransform: "none", borderRadius: 10 }}
        >
          Go Back
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: 10 }}
        >
          Submit Anyway
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubmitConfirmDialog;
